export default __webpack_public_path__ + "static/media/dark-mode.43251062.svg";